import { render } from "./SVGLogo.vue?vue&type=template&id=6f465d43"
import script from "./SVGLogo.vue?vue&type=script&lang=js"
export * from "./SVGLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../SINTEZ/store/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__